<template>
	<section>
		<!-- User -->
		<div class="logged-user header__logged-user flex list__item" @click="isShowed = !isShowed" v-if="logged">
			<div class="logged-user__avatar-wrap">
				<user-avatar v-if="isDoctor" :data="clinic" :set-class="'logged-user__avatar'"></user-avatar>
				<user-avatar v-else :data="account" :set-class="'logged-user__avatar'"></user-avatar>
			</div>
			<i class="logged-user__icon icon ion-chevron-down" :class="{'revert' : isShowed}"></i>
		</div>
		<!-- User End -->

		<!-- User -->
		<div class="user mobile-menu-list__user" v-if="!logged">
			<router-link :to="{name: 'Login'}" class="user__enter">Вход</router-link>
			<router-link :to="{name: 'One'}" class="user__registration">Регистрация</router-link>
		</div>
		<!-- User End -->

		<div class="outer_account" v-if="isShowed && overlay" @click="isShowed = false"></div>

		<!-- Account -->
		<div class="account" v-if="isShowed">

			<div class="account__inner clear_fix flex">
				<div class="account__avatar-wrap">
					<user-avatar v-if="isDoctor" :data="clinic" :set-class="'account__avatar'"></user-avatar>
					<user-avatar v-else :data="account" :set-class="'account__avatar'"></user-avatar>
				</div>

				<div class="account__content" v-if="isDoctor">
					<div class="account__title">{{account.clinic_name}}</div>
					<div class="account__subtitle">{{account.role.name}}</div>
					<div class="account__subtitle blue">Активный кабинет</div>
				</div>

				<div class="account__content" v-else>
					<div class="account__title">{{account.first_name}} {{account.last_name}}</div>
					<div class="account__subtitle">Личный кабинет</div>
					<div class="account__subtitle blue">Активный кабинет</div>
				</div>
			</div>

			<div v-for="room in rooms" @click="selectRoom(room)"
					 class="account__inner clear_fix account__inner_bg flex account__inner_item	">

				<div class="account__avatar-wrap">
					<user-avatar :data="room" :setClass="'account__avatar account__avatar_size_s'"></user-avatar>
				</div>

				<div class="account__content" v-if="room.sex">
					<div class="account__title">{{room.first_name}} {{room.last_name}}</div>
					<div class="account__subtitle">Личный кабинет</div>
				</div>

				<div class="account__content" v-else>
					<div class="account__title">{{room.clinic_name}}</div>
					<div class="account__subtitle">{{room.role.name}}</div>
				</div>
			</div>

			<div class="account__inner account__inner_bg flex">
				<div class="account__btns">

					<div class="account__link-box account__link-box_text_l">
						<a @click="settings" class="account__btn-setting trans">Настройки</a>
					</div>

					<div class="account__link-box account__link-box_text_r">
						<a @click="logout" class="account__btn-exit trans">Выйти</a>
					</div>

				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import Role from '@/common/Role'

	export default {
		name: "AccountSwitcher",
		props: ['rooms', 'overlay'],
		computed: {
			isDoctor() {
				return this.$store.state.auth.isDoctor
			},
			clinic() {
				return this.$store.state.auth.clinic
			},
			logged() {
				return this.$store.state.auth.logged
			},
			account() {
				if (this.$store.state.auth.isDoctor) {
					return this.$store.state.auth.worker
				}

				return this.$store.state.auth.user
			}
		},
		data() {
			return {
				isShowed: false
			}
		},
		methods: {
			selectRoom(roomObject) {
				this.isShowed = false

				if (roomObject.sex) {
					this.$store.commit('auth/setWorker', {})
					this.$store.commit('auth/setClinic', {})

					this.$storage.removeMore(['clinic', 'worker'])

					this.redirect(roomObject)
				} else {
					this.$store.dispatch('worker/get', roomObject._id).then(response => {
						this.$store.commit('auth/setWorker', response)
						this.redirect(roomObject)

						this.Role = new Role(this.user, response, this.clinic)
					}).then(() => {
						return this.$store.dispatch('clinic/get', roomObject.clinic_id)
					}).then(response => {
						this.$store.commit('auth/setClinic', response)
					})
				}
			},
			redirect(user) {
				this.$router.push({
					name: 'Events',
					params: {
						id: user._id
					}
				})
			},
			settings() {
				this.$router.push('/setting')
				this.isShowed = false
			},
			logout() {
				this.$store.dispatch('auth/logout')
				this.$router.replace('/')
				this.isShowed = false
			}
		}
	}
</script>

<style scoped>
	@media screen and (max-width: 768px) {
		.account {
			position: static;
			width: auto;
		}
	}

	.outer_account {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 9;
	}
</style>



// WEBPACK FOOTER //
// AccountSwitcher.vue?0700e9fd